/* src/app/dialogs/activation-editor/activation-editor.component.css */
/*# sourceMappingURL=activation-editor.component-U6SNCC7D.css.map */
